import React, {useState, useEffect} from "react";
import "../../styles/ViewMap.css";
import { GoogleMap, MarkerF, useJsApiLoader, InfoWindowF } from '@react-google-maps/api'
import { GOOGLE_API_KEY } from "../../data/APIEndpoints";
import { Box } from "@mui/material";

function ViewMap(props) {
  const { mapDetails, handleViewMap, heightValue } = props;
  const [selectedElement, setSelectedElement] = useState(false);
  const [selectedElementData, setSelectedElementData] = useState({});
  const [selectedPlace, setselectedPlace] = useState("");
  const [map, setMap] = useState(null)
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_API_KEY,
    libraries: ['geometry'],
  });

  const originIcon = {
    url: require("../../assets/location.svg").default,
  };

  const destinationIcon = {
    url: require("../../assets/logos/map-home.svg").default,
  };

  const getRouteData = async (googleMap) => {
    const requestData = {
      origin: {
        location: {
          latLng: {
            latitude: mapDetails[0].lat, 
            longitude: mapDetails[0].lng
          }
        }
      },
      destination: {
        location: {
          latLng: {
            latitude: mapDetails[1].lat, 
            longitude: mapDetails[1].lng
          }
        }
      },
      travelMode: 'DRIVE'
    };
    await fetch('https://routes.googleapis.com/directions/v2:computeRoutes?key=' + GOOGLE_API_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-FieldMask': 'routes.polyline.encodedPolyline',
      },
      body: JSON.stringify(requestData)
    })
    .then(response => response.json())
    .then(data => {
      const encodedPolyline = data.routes[0]?.polyline?.encodedPolyline;
      if (!encodedPolyline) {
        console.error('No polyline data found');
        return;
      }
      if (encodedPolyline && window.google.maps.geometry) {
        const path = window.google.maps.geometry.encoding.decodePath(encodedPolyline);
        const polyline = new window.google.maps.Polyline({
          path: path,
          geodesic: true,
          strokeColor: '#65aaf0',
          strokeOpacity: 1.0,
          strokeWeight: 5,
        });
        polyline.setMap(googleMap);
      } else {
        console.error('Google Maps Geometry library not available');
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  };

  const onLoad = (map) => {
      const bounds = new window.google.maps.LatLngBounds();
      mapDetails?.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
      map.fitBounds(bounds);
      setMap(map);
      getRouteData(map)
      window.google.maps.event.addListener(map, 'click', function(){
        setSelectedElement(false);
        setSelectedElementData({});
        setselectedPlace("");
      });
  };

  useEffect(() => {
    if (map) {
      const legend = document.createElement('div');
      legend.id = 'legend';
      legend.style.padding = '10px';
      legend.style.backgroundColor = 'white';
      legend.style.fontSize = '14px';
      legend.style.borderRadius = '3px';
      legend.style.marginLeft = "10px";
      const originItem = document.createElement('div');
      originItem.innerHTML = `<img src="${originIcon.url}" alt="Origin Icon" width="24" height="24" style="vertical-align: middle;" /> Origin <br>`;
      legend.appendChild(originItem);
      const destinationItem = document.createElement('div');
      destinationItem.innerHTML = `<img src="${destinationIcon.url}" alt="Destination Icon" width="24" height="24" style="vertical-align: middle;" /> Destination <br>`;
      legend.appendChild(destinationItem);
      map.controls[window.google.maps.ControlPosition.INLINE_START_BLOCK_START].push(legend);
    }
    // eslint-disable-next-line
  }, [map]);

  return (
    <Box className="map-section">
    {
      isLoaded ? (
        <GoogleMap
          mapContainerStyle={{
            width: "28vw",
            height: heightValue
          }}
          center={{
            lat: mapDetails[0]?.lat,
            lng: mapDetails[0]?.lng,
          }}
          zoom={3}
          onLoad={onLoad}
          options={{
            fullscreenControl: false,
            mapTypeControlOptions:{
              style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
              position: window.google.maps.ControlPosition.LEFT_TOP,
              mapTypeIds: [
                window.google.maps.MapTypeId.ROADMAP,
                window.google.maps.MapTypeId.HYBRID,
                window.google.maps.MapTypeId.SATELLITE,
                window.google.maps.MapTypeId.TERRAIN
              ]
            }
          }}
        >
          <MarkerF key={0} position={{ lat: mapDetails[0].lat, lng: mapDetails[0].lng }} 
            onClick={() => {
              setSelectedElement(true);
              setSelectedElementData(mapDetails[0]);
              setselectedPlace("Origin")
            }}
            icon={{
              url: require("../../assets/location.svg").default,
              anchor: new window.google.maps.Point(11, 10)
            }} 
          />
          <MarkerF key={1} position={{ lat: mapDetails[1].lat, lng: mapDetails[1].lng }}
            onClick={() => {
              setSelectedElement(true);
              setSelectedElementData(mapDetails[1]);
              setselectedPlace("Destination")
            }}
            icon={{
              url: require("../../assets/logos/map-home.svg").default,
              anchor: new window.google.maps.Point(11, 11)
            }} 
          />
          {selectedElement && (
            <InfoWindowF position={{
              lat: selectedElementData.lat,
              lng: selectedElementData.lng
            }} options={{
              headerContent: selectedPlace
            }}
            onCloseClick={() => {
              setSelectedElement(false);
              setSelectedElementData({});
              setselectedPlace("");
            }}>
              <span style={{fontFamily: '"Inter", sans-serif'}}>{selectedElementData.address}</span>
            </InfoWindowF>
          )}
          <Box sx={{ position: 'relative', paddingTop: "1rem", float: "right", paddingRight: "15px" }}>
            <img src={require("../../assets/logos/cancel.svg").default} width="30px"
              height="30px" alt="delete" onClick={handleViewMap} />
          </Box>
        </GoogleMap>
      ) : (
        <></>
      )
    }
    </Box>
  );
}

export default ViewMap;
